import {
  EyeIcon,
  TrashIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";
import { useTxn } from "@moonscape/shared";
import { useContext } from "react";
import { TransactionListContext } from "@/contexts";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export const TradeItemMenu = ({ t, view }) => {
  const { setIsRefresh, setIsEditing } = useContext(TransactionListContext);
  const {
    mutate: deleteOrStoreTxn,
    isPending: isPendingTxn,
    isError: isErrorTxn,
  } = useTxn({
    onSuccess: () => {
      setIsRefresh(true);
    },
    onError: () => null,
  });
  return (
    <DropdownMenuContent>
      <DropdownMenuItem onClick={() => view()}>
        <EyeIcon className="h-4 w-4 mr-2" aria-hidden="true" />
        View
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => { setIsEditing(true); view(); }}>
        <PencilSquareIcon className="h-4 w-4 mr-2" aria-hidden="true" />
        Edit
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem danger onClick={() => deleteOrStoreTxn(t)}>
        <TrashIcon className="h-4 w-4 mr-2" aria-hidden="true" />
        {t.deleted ? "Restore" : "Delete"}
      </DropdownMenuItem>
    </DropdownMenuContent>
  );
};
